// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// constants
import { BESTSELLERS_PRICE_LIST_TITLE, HEADER_LABEL, HEADER_PRICE_LABEL } from './constants';

// styles
import {
  Container,
  Title,
  TableHeader,
  HeaderLabel,
  HeaderPriceLabel,
  ItemList,
  Item,
  ItemLink,
  ProductName,
  ProductPrice,
} from './styles';

// types
import { IBestsellersPriceListProps } from './types';


const formatPrice = (price: number) => `₹${Number(price).toLocaleString('en-IN')}`;

function BestsellersPriceList({
  title = BESTSELLERS_PRICE_LIST_TITLE,
  headerLabel = HEADER_LABEL,
  headerPriceLabel = HEADER_PRICE_LABEL,
  items = [],
}: IBestsellersPriceListProps) {
  if (isEmpty(items)) return null;

  return (
    <Container data-test="bestsellers-price-list" data-at="bestsellers-price-list">
      <Title>{title}</Title>
      <TableHeader>
        <HeaderLabel>{headerLabel}</HeaderLabel>
        <HeaderPriceLabel>{headerPriceLabel}</HeaderPriceLabel>
      </TableHeader>
      <ItemList>
        {items.map((item) => (
          <Item key={`${item.name}-${item.price}`}>
            <ItemLink href={item.link} data-test="bestseller-item">
              <ProductName>{item.name}</ProductName>
              <ProductPrice>{formatPrice(item.price)}</ProductPrice>
            </ItemLink>
          </Item>
        ))}
      </ItemList>
    </Container>
  );
}

export default memo(BestsellersPriceList);
